export var DEPRECATED_CATCH_TYPE = 'catchClick';
export var SYNTHETIC_TYPES = [
    'onClick',
    'onTap',
    'onLongClick',
    'onLongTap',
    'onTouchMove',
    'onTouchStart',
    'onTouchEnd',
];
